import {generatePath} from "react-router-dom";

export default {
    home: {
        path: '/',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    combo: {
        path: '/combo/:slug',
        getUrl: function (slug) {
            return buildUrl(this, {slug});
        }
    },
    course: {
        path: '/course/:slug',
        getUrl: function (slug) {
            return buildUrl(this, {slug});
        }
    },
    article: {
        path: '/article/:slug',
        getUrl: function (slug) {
            return buildUrl(this, {slug});
        }
    },
    promotion: {
        path: '/promotion/:slug',
        getUrl: function (slug) {
            return buildUrl(this, {slug});
        }
    },
    library: {
        path: '/library',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    learning: {
        path: '/learning/:courseId/:lessonId',
        getUrl: function (courseId, lessonId) {
            return buildUrl(this, {courseId, lessonId});
        }
    },
    help: {
        path: '/help',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    user_profile: {
        path: '/user/:id',
        getUrl: function (id) {
            return buildUrl(this, {id});
        }
    },
    account: {
        path: '/account',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    register: {
        path: '/register',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    login: {
        path: '/login',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    forgot_password: {
        path: '/forgot-password',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    reset_password: {
        path: '/reset-password',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    verify_email: {
        path: '/verify-email',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    terms_and_conditions: {
        path: '/terms-and-conditions',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    privacy_policy: {
        path: '/privacy-policy',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    checkout: {
        path: '/checkout/:type(course|combo)/:id',
        getUrl: function (type, id) {
            return buildUrl(this, {type, id});
        }
    },
    dashboard: {
        path: '/dashboard',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    image_management: {
        path: '/image-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    video_management: {
        path: '/video-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    audio_management: {
        path: '/audio-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    document_management: {
        path: '/document-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    banner_management: {
        path: '/banner-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    article_management: {
        path: '/article-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    promotion_management: {
        path: '/promotion-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    combo_management: {
        path: '/combo-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    course_management: {
        path: '/course-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    chapter_management: {
        path: '/chapter-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    lesson_management: {
        path: '/lesson-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    enrollment_management: {
        path: '/enrollment-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    user_management: {
        path: '/user-management',
        getUrl: function () {
            return buildUrl(this);
        }
    },
    quiz_management: {
        path: '/quiz-management',
        getUrl: function () {
            return buildUrl(this);
        }
    }
}

function buildUrl(route, params = {}) {
    return generatePath(route.path, params);
}
